const initialState = {
    pageNo: 0,
    status: "any",
    domain: null,
    sort: "desc",
    search: "",
    assignedTo: null,
    subject: "",
    threadId: "",
    emailBody: "",
    from: '',
    data: [],
    count: 0,
    isLoading: false,
    refresh:'10'
}

const emailTicketReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SET_TICKET_RECORDS":
      return { ...state, ...payload }  
    case "ET_UPDATE_PAGE_NO":
      return { ...state, pageNo: payload }; 
    case "ET_UPDATE_SORT":
      return { ...state, sort: payload, pageNo: 0 };
    case "ET_UPDATE_STATUS":
        return { ...state, status: payload };
    case "ET_UPDATE_CATEGORY":
        return { ...state, domain: payload };
    case "ET_UPDATE_SEARCH":
        return { ...state, search: payload, pageNo: 0 };
    case "ET_UPDATE_ASSIGNEE":
        return { ...state, assignedTo: payload };
    case "ET_UPDATE_SUBJECT":
        return { ...state, subject: payload };
    case "ET_UPDATE_TICKET_ID":
        return { ...state, threadId: payload };
    case "ET_UPDATE_EMAIL_BODY":
        return { ...state, emailBody: payload };
    case "ET_UPDATE_FROM":
        return { ...state, from: payload };
    case "ET_RESET_TICKET_RECORDS":
      return initialState;
    case "ET_UPDATE_TICKET_DATA":
      return { ...state, data: payload };
    case "ET_UPDATE_TICKET_COUNT":
      return { ...state, count: payload };
    case "ET_UPDATE_IS_LOADING":
      return { ...state, isLoading: payload };
    case "ET_UPDATE_REFRESH":
      return { ...state, refresh: Math.random()*10 };
    case "ET_UPDATE_Bulk_REFRESH":
      return { ...state, refresh: Math.random()*10,pageNo: 0, ...payload };
  default:
    return state
  }
}
export default emailTicketReducer;